<template>
  <div v-wechat-title="$route.meta.title" class="discover-warp">
    <div class="discover-head">
      Discover
    </div>
    <div class="discover-icons">
      <Icons />
    </div>
    <div class="discover-maps">
      <Jobs :preference="preference"/>
    </div>
<!--    <Modal :page="'Discover Page'" :saveInfo="saveInfo"/> &lt;!&ndash;:visible="drawer"&ndash;&gt;-->
  </div>
</template>

<script>
import Icons from './icons.vue'
import Jobs from './jobs/index.vue';
// import Modal from './modal.vue'
import mixpanel from '@/utils/mixpanel.js'
import {getCookies} from '@/tools/cookie';
export default {
  name: "Index",
  components: {
    Icons, Jobs,
    // Modal
  },
  data() {
    return{
      drawer: true,
      preference: {}
    }
  },
  created() {
    const {userId, distinct, deviceId, version} = getCookies();
    mixpanel.initMixpanel(process.env['VUE_APP_MIX_KEY']);
    mixpanel.identify(distinct);
    mixpanel.register({
      'Distinct ID': distinct, //公共参数
      'Device ID': deviceId,  //公共参数
      'User ID': userId,
      'App Version': version
    });
  },
  methods: {
    // saveInfo(data) {
    //   console.log(data, '========saveInfo')
    // }
  }
}
</script>

<style scoped>
@font-face {
    font-family: SFProText-Semibold;
    src: url(../../assets/fonts/SF-Pro-Text-Semibold.otf);
}
.discover-warp{
  width: 100%;
  /* 不要设置，否则无法动态加载 */
  /* height: 100%; */
  height: auto;
  overflow-x: hidden;
  overflow-y: scroll;
  /*max-width: 500px;*/
  margin: 0 auto;
  color: #141A42;
  opacity: 1;
  background: rgb(255, 255, 255);
}
.discover-head {
  font-family: SFProText-Semibold;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 11px 51px;
  border-bottom: 1px solid #e7ebf3;
}
</style>
